module.exports = __webpack_public_path__ + "img/foncabsa.ec13500c.svg";